import React from "react";
import { Link } from "react-router-dom";

const Section = ({ title, children }) => (
  <div style={{ marginBottom: 40 }}>
    <h2 style={{
      color: "#f5c200",
      fontWeight: 800,
      fontSize: "1.1rem",
      textTransform: "uppercase",
      letterSpacing: "0.1em",
      marginBottom: 12,
      borderLeft: "4px solid #2a7a6f",
      paddingLeft: 14,
    }}>
      {title}
    </h2>
    <div style={{ color: "#ccc", fontSize: "0.95rem", lineHeight: 1.8 }}>
      {children}
    </div>
  </div>
);

const RightCard = ({ icon, title, desc }) => (
  <div style={{
    background: "#1a1a1a",
    border: "1px solid #2a2a2a",
    borderRadius: 8,
    padding: "16px 20px",
    display: "flex",
    gap: 14,
    alignItems: "flex-start",
  }}>
    <span style={{ fontSize: "1.4rem", marginTop: 2 }}>{icon}</span>
    <div>
      <div style={{ color: "#f7f4ee", fontWeight: 700, marginBottom: 4 }}>{title}</div>
      <div style={{ color: "#aaa", fontSize: "0.9rem" }}>{desc}</div>
    </div>
  </div>
);

export default function Confidentialite() {
  return (
    <div style={{ background: "#0d1117", minHeight: "100vh", paddingBottom: 80 }}>
      {/* Header */}
      <div style={{
        background: "#1a1a1a",
        borderBottom: "3px solid #f5c200",
        padding: "60px 24px 40px",
        textAlign: "center",
      }}>
        <div style={{ fontSize: "2.5rem", marginBottom: 12 }}>🔒</div>
        <h1 style={{
          color: "#f7f4ee",
          fontWeight: 900,
          fontSize: "clamp(1.6rem, 4vw, 2.5rem)",
          marginBottom: 12,
        }}>
          Politique de Confidentialité
        </h1>
        <p style={{ color: "#aaa", fontSize: "0.95rem", maxWidth: 560, margin: "0 auto" }}>
          Dernière mise à jour : juin 2026 — Starting Five, Lomé, Togo
        </p>
      </div>

      {/* Contenu */}
      <div style={{ maxWidth: 860, margin: "0 auto", padding: "48px 24px" }}>

        <Section title="Introduction">
          <p>
            <strong style={{ color: "#f7f4ee" }}>Starting Five</strong> accorde une grande importance à
            la protection de vos données personnelles. La présente Politique de Confidentialité décrit
            quelles données nous collectons, comment nous les utilisons, et quels droits vous disposez
            sur ces données.
          </p>
          <p style={{ marginTop: 12 }}>
            En utilisant notre Site, vous acceptez les pratiques décrites dans ce document.
          </p>
        </Section>

        <Section title="Responsable du traitement">
          <p>Le responsable du traitement des données est :</p>
          <div style={{
            marginTop: 16,
            background: "#1a1a1a",
            border: "1px solid #2a2a2a",
            borderRadius: 8,
            padding: "20px 24px",
            display: "inline-block",
          }}>
            <div style={{ color: "#f7f4ee", fontWeight: 700, marginBottom: 8 }}>Starting Five</div>
            <div style={{ color: "#aaa", fontSize: "0.9rem", lineHeight: 2 }}>
              📧 contact@startingfive.tg<br />
              📞 +228 90 47 87 25<br />
              📍 Cité Mokpokpo, Adidogomé Lomé, Togo
            </div>
          </div>
        </Section>

        <Section title="Données collectées">
          <p>Nous collectons les données suivantes, selon vos interactions avec le Site :</p>
          <div style={{ marginTop: 16, display: "flex", flexDirection: "column", gap: 10 }}>
            {[
              {
                category: "Données d'identification",
                examples: "Nom, prénom, adresse email, numéro de téléphone",
                when: "Lors de la création d'un compte ou de l'envoi d'un formulaire de contact",
              },
              {
                category: "Données de connexion",
                examples: "Adresse IP, token de session JWT, horodatage de connexion",
                when: "Automatiquement lors de chaque connexion",
              },
              {
                category: "Données de navigation",
                examples: "Pages visitées, durée de visite, provenance (via Google Analytics)",
                when: "Avec votre consentement préalable",
              },
            ].map((item, i) => (
              <div key={i} style={{
                background: "#1a1a1a",
                border: "1px solid #2a2a2a",
                borderRadius: 8,
                padding: "16px 20px",
              }}>
                <div style={{ color: "#f5c200", fontWeight: 700, fontSize: "0.85rem", marginBottom: 4 }}>
                  {item.category}
                </div>
                <div style={{ color: "#f7f4ee", fontSize: "0.9rem", marginBottom: 4 }}>
                  {item.examples}
                </div>
                <div style={{ color: "#666", fontSize: "0.82rem" }}>
                  ↳ {item.when}
                </div>
              </div>
            ))}
          </div>
        </Section>

        <Section title="Finalités du traitement">
          <p>Vos données sont collectées pour les finalités suivantes :</p>
          <ul style={{ marginTop: 12, paddingLeft: 20, display: "flex", flexDirection: "column", gap: 8 }}>
            {[
              "Gestion de votre compte utilisateur et maintien de votre session de connexion",
              "Réponse à vos demandes de contact ou de support",
              "Envoi de notifications liées à votre compte (si vous avez consenti à recevoir des emails)",
              "Amélioration continue du Site grâce à des statistiques de navigation anonymisées",
              "Respect de nos obligations légales et contractuelles",
            ].map((item, i) => (
              <li key={i} style={{ color: "#ccc" }}>{item}</li>
            ))}
          </ul>
        </Section>

        <Section title="Base légale du traitement">
          <p>
            Nous traitons vos données sur la base de votre <strong style={{ color: "#f7f4ee" }}>consentement</strong>
            {" "}(pour les cookies analytiques), de l'<strong style={{ color: "#f7f4ee" }}>exécution d'un contrat</strong>
            {" "}(pour la gestion de votre compte) et de nos <strong style={{ color: "#f7f4ee" }}>intérêts légitimes</strong>
            {" "}(pour la sécurité et l'amélioration du Site).
          </p>
        </Section>

        <Section title="Conservation des données">
          <p>
            Vos données personnelles sont conservées pour une durée limitée, proportionnée à leur finalité :
          </p>
          <div style={{ marginTop: 14, display: "flex", flexDirection: "column", gap: 10 }}>
            {[
              { label: "Données de compte", duree: "Durée de vie du compte + 3 ans après sa suppression" },
              { label: "Données de contact", duree: "3 ans à compter de votre dernier contact" },
              { label: "Données de navigation (Analytics)", duree: "26 mois maximum" },
            ].map((item, i) => (
              <div key={i} style={{
                background: "#1a1a1a",
                border: "1px solid #2a2a2a",
                borderRadius: 8,
                padding: "12px 20px",
                display: "flex",
                justifyContent: "space-between",
                flexWrap: "wrap",
                gap: 8,
              }}>
                <span style={{ color: "#f7f4ee", fontWeight: 600 }}>{item.label}</span>
                <span style={{ color: "#aaa", fontSize: "0.9rem" }}>{item.duree}</span>
              </div>
            ))}
          </div>
        </Section>

        <Section title="Vos droits">
          <p>Conformément à la réglementation applicable, vous disposez des droits suivants :</p>
          <div style={{ marginTop: 16, display: "flex", flexDirection: "column", gap: 12 }}>
            <RightCard
              icon="👁️"
              title="Droit d'accès"
              desc="Vous pouvez demander à consulter les données personnelles que nous détenons sur vous."
            />
            <RightCard
              icon="✏️"
              title="Droit de rectification"
              desc="Vous pouvez demander la correction de données inexactes ou incomplètes."
            />
            <RightCard
              icon="🗑️"
              title="Droit à l'effacement"
              desc="Vous pouvez demander la suppression de vos données, sous réserve de nos obligations légales."
            />
            <RightCard
              icon="🚫"
              title="Droit d'opposition"
              desc="Vous pouvez vous opposer au traitement de vos données à des fins de prospection ou d'analyse."
            />
            <RightCard
              icon="📦"
              title="Droit à la portabilité"
              desc="Vous pouvez demander à recevoir vos données dans un format structuré et lisible par machine."
            />
          </div>
          <p style={{ marginTop: 20 }}>
            Pour exercer l'un de ces droits, contactez-nous à{" "}
            <a href="mailto:contact@startingfive.tg" style={{ color: "#2a7a6f" }}>
              contact@startingfive.tg
            </a>
            . Nous nous engageons à répondre dans un délai de 30 jours.
          </p>
        </Section>

        <Section title="Sécurité des données">
          <p>
            Starting Five met en œuvre des mesures techniques et organisationnelles appropriées pour
            protéger vos données personnelles contre tout accès non autorisé, perte, altération ou
            divulgation. Les mots de passe sont stockés de manière chiffrée et les communications
            sont sécurisées via HTTPS.
          </p>
        </Section>

        <Section title="Partage avec des tiers">
          <p>
            Nous ne vendons pas vos données personnelles à des tiers. Vos données peuvent être partagées
            avec des prestataires techniques nécessaires au fonctionnement du Site (ex. hébergeur,
            service d'emailing, Google Analytics), dans le strict respect de leur finalité.
          </p>
          <p style={{ marginTop: 12 }}>
            Google Analytics peut traiter certaines données de navigation conformément à sa{" "}
            <a
              href="https://policies.google.com/privacy"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#2a7a6f" }}
            >
              politique de confidentialité
            </a>
            .
          </p>
        </Section>

        <Section title="Modifications de cette politique">
          <p>
            Nous pouvons mettre à jour cette Politique de Confidentialité à tout moment. Toute
            modification sera publiée sur cette page avec une date de mise à jour révisée. Nous vous
            encourageons à consulter régulièrement cette page.
          </p>
        </Section>

        {/* Retour */}
        <div style={{ marginTop: 48, textAlign: "center" }}>
          <Link to="/" style={{
            color: "#2a7a6f",
            textDecoration: "none",
            fontWeight: 600,
            fontSize: "0.95rem",
          }}>
            ← Retour à l'accueil
          </Link>
        </div>
      </div>
    </div>
  );
}
